import script from "./Guests.vue?vue&type=script&setup=true&lang=ts"
export * from "./Guests.vue?vue&type=script&setup=true&lang=ts"

import "./Guests.vue?vue&type=style&index=0&id=b5985128&scoped=true&lang=css"

import exportComponent from "/var/www/zioncallmanagement.com/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5985128"]])

export default __exports__